var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreaterRoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.43,
    height: 42.429,
    viewBox: "0 0 42.43 42.429",
    fill: "#5D44FF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refund_8831351",
    transform: "translate(-433.005 -241.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OUTLINE",
    transform: "translate(433.005 241.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M440.037,246.438l-1.185-.736a3.112,3.112,0,0,0-4.753,2.742l.143,4.48a3.111,3.111,0,0,0,4.4,2.734l4.081-1.855a3.112,3.112,0,0,0,.355-5.476l-.522-.324a18.4,18.4,0,1,1-6.428,10.948,1.415,1.415,0,1,0-2.785-.5,21.217,21.217,0,1,0,6.7-12.014Zm-2.968,6.4-.143-4.48a.284.284,0,0,1,.141-.255.281.281,0,0,1,.29,0l4.224,2.627a.28.28,0,0,1,.133.257.286.286,0,0,1-.165.24l-4.081,1.855a.282.282,0,0,1-.266-.018.279.279,0,0,1-.133-.231Z",
    transform: "translate(-433.005 -241.006)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M447.829,252.842a3.11,3.11,0,0,0-2.829,3.1v.849a3.11,3.11,0,0,0,3.112,3.112h2.263a.285.285,0,0,1,.283.283v.849a.285.285,0,0,1-.283.283h-3.961a1.415,1.415,0,1,0,0,2.829h1.415v1.415a1.415,1.415,0,1,0,2.829,0v-1.427a3.11,3.11,0,0,0,2.829-3.1v-.849a3.11,3.11,0,0,0-3.112-3.112h-2.263a.285.285,0,0,1-.283-.283v-.849a.285.285,0,0,1,.283-.283h3.961a1.415,1.415,0,0,0,0-2.829h-1.415v-1.415a1.415,1.415,0,1,0-2.829,0Z",
    transform: "translate(-428.032 -237.277)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(8.306 8.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M177.313,54.959a12.722,12.722,0,1,0,12.722,12.722A12.728,12.728,0,0,0,177.313,54.959Zm0,2.827a9.895,9.895,0,1,1-9.895,9.895A9.9,9.9,0,0,1,177.313,57.786Z",
    transform: "translate(-164.591 -54.959)",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterRoi);
export default __webpack_public_path__ + "static/media/greaterRoi.694485c245067609eb7567e647b56784.svg";
export { ForwardRef as ReactComponent };